module.exports = __webpack_public_path__ + "img/7_003.88960c5c.webp";